import React from 'react';
import { Col, Form, InputGroup, Row } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { default as Selector } from 'react-select';
import PropTypes from 'prop-types';

export default function HeaderAzul({
  title,
  contemPesquisa = false,
  contemSelector = false,
  botaoVoltar = false,
  onVoltar,
  setPesquisa,
  pesquisa = '',
  searchPlaceholder = 'Código ou Descrição',
  options = [],
  selectorValue = null,
  onSelectorChange = () => {},
  onSelectorBlur = () => {},
  selectorPlaceholder = 'Selecione uma opção...',
  selectorLoading = false,
  selectorError = null,
  selectorDisabled = false,
  selectorName = 'selector',
  selectorInputId = 'selector-input',
  selectorIsSearchable = true,
  selectorIsClearable = true,
  contemTabs = false,
  tabs = [],
  activeTab = null,
  onTabChange = () => {},
}) {
  const searchStyles = {
    searchInput: {
      minWidth: '250px',
      maxWidth: '700px',
      borderRadius: '8px 0px 0px 8px',
    },
  };

  const getSelectorPlaceholder = () => {
    if (selectorLoading) return 'Carregando...';
    if (selectorError) return `Erro: ${selectorError}`;
    if (!options || options.length === 0) return 'Nenhuma opção disponível';
    return selectorPlaceholder;
  };

  if (contemPesquisa && contemSelector) {
    console.warn(
      'HeaderAzul: Não é recomendado usar pesquisa e selector simultaneamente. Considere usar apenas um.'
    );
  }

  if (contemTabs && (contemPesquisa || contemSelector)) {
    console.warn(
      'HeaderAzul: Não é recomendado usar tabs com pesquisa ou selector simultaneamente.'
    );
  }

  return (
    <Row
      className="py-3 mb-3 mx-auto justify-content-between align-items-center"
      style={{
        backgroundColor: '#0747a6',
        borderRadius: '8px',
        color: '#fff',
      }}
    >
      <Col xs={12} md={8} className="mb-2 mb-md-0 d-flex align-items-center">
        {botaoVoltar && (
          <button
            onClick={onVoltar}
            style={{
              width: '32px',
              height: '32px',
              backgroundColor: '#fff',
              border: 'none',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              marginLeft: '8px',
              marginRight: '8px',
              flexShrink: 0,
            }}
          >
            <FaArrowLeft style={{ color: '#0747a6', fontSize: '14px' }} />
          </button>
        )}
        <h4 className="mb-0 px-2">{title}</h4>
      </Col>

      {contemPesquisa && (
        <Col xs={12} md={4} className="px-3">
          <InputGroup>
            <Form.Control
              type="text"
              placeholder={searchPlaceholder}
              value={pesquisa}
              onChange={e => setPesquisa(e.target.value)}
              className="search-input"
              style={searchStyles.searchInput}
              aria-label="Campo de pesquisa"
            />
            <InputGroup.Text
              style={{
                borderRadius: '0 8px 8px 0',
                cursor: 'pointer',
                backgroundColor: '#fff',
              }}
              onClick={() => setPesquisa('')}
              role="button"
              aria-label="Limpar pesquisa"
              tabIndex={0}
              onKeyPress={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  setPesquisa('');
                }
              }}
            >
              ✕
            </InputGroup.Text>
          </InputGroup>
        </Col>
      )}

      {contemSelector && (
        <Col xs={12} md={4} className="px-3">
          <div style={{ minWidth: '250px' }}>
            <Selector
              inputId={selectorInputId}
              styles={customStyles}
              components={{ DropdownIndicator }}
              name={selectorName}
              isSearchable={selectorIsSearchable}
              isClearable={selectorIsClearable}
              options={options}
              value={selectorValue}
              onChange={selected => {
                onSelectorChange(selected);
                if (selected && onSelectorBlur) {
                  setTimeout(() => onSelectorBlur(selected), 100);
                }
              }}
              placeholder={getSelectorPlaceholder()}
              isDisabled={selectorDisabled || selectorLoading}
              isLoading={selectorLoading}
              noOptionsMessage={() => 'Nenhuma opção encontrada'}
              loadingMessage={() => 'Carregando opções...'}
              aria-label="Seletor de opções"
            />
          </div>
        </Col>
      )}

      {contemTabs && tabs.filter(tab => !tab.hidden).length > 0 && (
        <Col xs={12} md={4} className="px-3">
          <nav className="header-azul-tabs">
            <div className="header-azul-tabs__container">
              {tabs
                .filter(tab => !tab.hidden)
                .map(tab => (
                  <button
                    key={tab.key}
                    type="button"
                    className={`header-azul-tabs__item ${
                      activeTab === tab.key
                        ? 'header-azul-tabs__item--active'
                        : ''
                    }`}
                    onClick={() => onTabChange(tab.key)}
                    title={tab.label}
                  >
                    {tab.icon && (
                      <span className="header-azul-tabs__icon">{tab.icon}</span>
                    )}
                    <span className="header-azul-tabs__label">{tab.label}</span>
                  </button>
                ))}
            </div>
          </nav>
        </Col>
      )}
    </Row>
  );
}
